export default __webpack_public_path__ + "static/media/allianceHordeIcon.acadb85a.png";